import { invalidNumInputChars } from 'utils';

export const handleNumInputKeydown = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  if (invalidNumInputChars.includes(e.key)) {
    e.preventDefault();
  }
};
